module.exports = __webpack_public_path__ + "static/media/OJKLogo.bd27bc31.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/OJKLogo.png
// module id = 375
// module chunks = 11